import isEmpty from "lodash/isEmpty"

export default function validateInput(data) {
  let errors = {}

  const lang_code = localStorage.getItem("lang")

  const lang_required = {
    fr: {
      message_required: `Ce champ est requis`,
    },
    en: {
      message_required: `This field is required`,
    },
    sw: {
      message_required: `Ni lazima kujaza nafasi hii`,
    },
    es: {
      message_required: `Este campo es requerido`,
    },
    pt: {
      message_required: `Este campo é obrigatório`,
    },
  }

  const lang_digits_only = {
    fr: {
      message_required: `Entrez uniquement des chiffres`,
    },
    en: {
      message_required: `Enter digits only`,
    },
    sw: {
      message_required: `Ingiza tarakimu pekee`,
    },
    es: {
      message_required: `Inserta solo dígitos`,
    },
    pt: {
      message_required: `Insira apenas dígitos`,
    },
  }

  const lang_range = {
    fr: {
      message_required: `Montant compris entre 0 et 999999999`,
    },
    en: {
      message_required: `Amount between 0 and 999999999`,
    },
    sw: {
      message_required: `Kiasi kati ya 0 na 999999999`,
    },
    es: {
      message_required: `Importe entre 0 y 999999999`,
    },
    pt: {
      message_required: `Valor entre 0 e 999999999`,
    },
  }

  if (data.amount === "") {
    errors.amount = lang_required[lang_code].message_required
  }

  if (isNaN(data.amount)) {
    errors.amount = lang_digits_only[lang_code].message_required
  }

  if (data.amount < 0 || data.amount > 999999999) {
    errors.amount = lang_range[lang_code].message_required
  }

  if (data.sourceFundType === undefined) {
    errors.sourceFundType = lang_required[lang_code].message_required
  }

  if (data.sourceFundType === "") {
    errors.sourceFundType = lang_required[lang_code].message_required
  }

  return {
    errors,
    isValid: isEmpty(errors),
  }
}
